export default "__VITE_ASSET__Bi6WtymN__"